import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";

const vUI_Tag_Function_Search_Fields: {[id:string]: ISearchProviderField } = {
    WB_TAG_FUNCTION_ID:     {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'Id',                    columnResourceName: 'colId',              alignment: HorizAlignment.Center}, domainOptions: {}},
    TAG_FUNCTION_ID:       {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Tag Function ID',                   columnResourceName: 'colIdx',              alignment: HorizAlignment.Left},   domainOptions: {}},
    TAG_FUNCTION_NAME:  {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Tag Function Name',                  columnResourceName: 'colName',            alignment: HorizAlignment.Left},   domainOptions: {maxLength: 100}},
    TAG_TARGET:       {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Tag Target',     columnResourceName: 'colProductId',       alignment: HorizAlignment.Left}, domainOptions: {maxLength: 50}},
    CLASS_TYPE_ID:               {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Class Type',                  columnResourceName: 'colType',            alignment: HorizAlignment.Left},   domainOptions: {maxLength: 50}},
    CLASS_ID:    {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Class ID',                columnResourceName: 'colStatus',          alignment: HorizAlignment.Left},   domainOptions: {maxLength: 50}},
    CREATED_DTTS:   {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'Created DtTs', columnResourceName: 'colCreatedDtTs', alignment: HorizAlignment.Left}, domainOptions: {}},
    MODIFIED_DTTS:       {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'Modified DtTs', columnResourceName: 'colModifiedDtTs', alignment: HorizAlignment.Left}, domainOptions: {}},
    DELETED_IND:            {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Deleted Ind',           columnResourceName: 'colDeletedInd',      alignment: HorizAlignment.Left},   domainOptions: {}},
    DELETED_DT:             {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'Deleted Date',          columnResourceName: 'colDeleted_Date',    alignment: HorizAlignment.Center}, domainOptions: { maxLength: 50}}
}

const TagFunctionSearchProviderBasic: ISearchProvider = {

    keyFields: {id:    'WB_TAG_FUNCTION_ID',
                id_ui: 'TAG_FUNCTION_ID',
                name:  'TAG_FUNCTION_NAME'
    },

    searchProviderFields: vUI_Tag_Function_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_Tag_Function',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }
}

const TagFunctionSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "TagFunctionSearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'Id',     searchProviderFieldId: 'TAG_FUNCTION_ID', renderOptions: { }},
        {profileFilterName: 'Name',   searchProviderFieldId: 'TAG_FUNCTION_NAME', renderOptions: { }}
    ],  // ISearchFields
    profileDisplayFields: [
        'TAG_FUNCTION_ID', 'TAG_FUNCTION_NAME', 'TAG_TARGET', 'CLASS_TYPE_ID', 'CLASS_ID'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: TagFunctionSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];

}

const TagFunctionSearch: ISearch = {
    searchName: "Find Tag Function",
    renderOptions: { ui5ResourceId: "TagFunctionSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [TagFunctionSearchProfileByName]
}

export {TagFunctionSearch}